export default __webpack_public_path__ + "420e2c311299fef309ee62e11547c406.png";